import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import App from './App'
import { I18nProvider } from './i18n'
import { initNative } from './native/capacitor'
import { evictIfStale, STALE_LOAD_EVENT } from './utils/staleBuild'
import UpdateNotice from './components/UpdateNotice'
import StoreUpdateNotice from './components/StoreUpdateNotice'
import { STORE_UPDATE_PROMPT_ENABLED } from './config/featureFlags'
import './index.css'

// Native (Capacitor) bootstrap — no-ops on web.
initNative()

// Register service worker for PWA — web only.
// On native, an active SW interferes with serving bundled assets and web
// push doesn't deliver via APNs anyway.
// ★ One web guard for both halves of TEST 2.18: the at-load check below and the
//   UpdateNotice mounted in the render. Native builds get neither; they get the App
//   Store check instead (PROD-257, StoreUpdateNotice), dormant behind
//   STORE_UPDATE_PROMPT_ENABLED (scripts/check-store-update.mjs).
const isWeb = !Capacitor.isNativePlatform()
if (isWeb && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered, has scope:', !!registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
    // ★★★ AND THEN ASK WHETHER THIS CLIENT IS RUNNING A BUILD THE SERVER STILL SERVES.
    //   A bad build is over in minutes; a service worker holding a patient ON that build is
    //   not, and until 2026-09-09 nothing in this app was in a position to notice. Runs after
    //   `load`, so it never delays first paint, and it reloads at most once per session.
    //   When it gave up, or could not guard the reload, the notice offers the reload instead.
    evictIfStale()
      .then((outcome) => {
        if (outcome === 'gave-up' || outcome === 'guard-unavailable') {
          window.dispatchEvent(new CustomEvent(STALE_LOAD_EVENT, { detail: outcome }))
        }
      })
      .catch(() => {})
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {isWeb && <UpdateNotice />}
      {!isWeb && STORE_UPDATE_PROMPT_ENABLED && <StoreUpdateNotice />}
    </I18nProvider>
  </React.StrictMode>,
)
